module.exports = __webpack_public_path__ + "static/media/menuHandlerOpen.97646cc4.svg";